import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import seenLogo from "@/assets/seen-logo.png";

/** Site-wide footer, shared by every route that renders chrome. */
export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative bg-deep-chocolate text-surface py-4 md:py-3  before:absolute before:inset-x-0 before:top-0 before:h-px before:bg-gradient-to-r before:from-transparent before:via-golden-latte/50 before:to-transparent">
      <div className="max-w-[1440px] mx-auto px-grid-margin flex flex-col md:flex-row items-center justify-between gap-5">
        <Link to="/" aria-label="SEEN">
          <img
            src={seenLogo}
            alt="SEEN"
            className="h-14 md:h-16 w-auto object-contain brightness-0 invert opacity-90"
          />
        </Link>

        <Link
          to="/returns"
          className="text-label-md font-label-md text-surface/70 hover:text-golden-latte uppercase tracking-[0.2em] text-center underline-offset-4 hover:underline transition-colors duration-300"
        >
          {t("returns.title")}
        </Link>
      </div>
    </footer>
  );
}
